// src/components/Logo.js
import React, { useState } from "react";

const Logo = ({ className = "", size = 32, alt = "Pallium" }) => {
    const [hasTriedFallback, setHasTriedFallback] = useState(false);
    // Transparent 1x1 PNG data URI as a final fallback
    const fallbackDataUri = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/w8AAgMBAp2Qn1cAAAAASUVORK5CYII=";

    const handleError = (e) => {
        if (!hasTriedFallback) {
            setHasTriedFallback(true);
            e.currentTarget.src = "/logo192.png";
        } else {
            e.currentTarget.onerror = null;
            e.currentTarget.src = fallbackDataUri;
        }
    };

    return (
        <img
            src={hasTriedFallback ? "/logo192.png" : "/pallium_logo.svg"}
            onError={handleError}
            alt={alt}
            width={size}
            height={size}
            className={className}
        />
    );
};

export default Logo;

